module.exports = __webpack_public_path__ + "img/emptycart.cb87210d.svg";